import React from 'react';
import { Redirect } from 'react-router-dom';
import routers from '../../_helpers/routers';

const HomePage = () =>
  <Redirect to={routers.passportsPage.path}/>;

export default HomePage;
